import { useQuery } from 'react-query';

import { axios } from '@/lib/axios';

type ClientAccessResponse = {
  isActive: boolean;
  commercialOfferAccesses: [
    {
      borderCrossingServiceId: string;
      folderTypologyId: string;
    },
  ];
};

const getClientAccessAsync = () => axios.get<ClientAccessResponse>('/clients/access');

export const useGetClientAccessAsync = () =>
  useQuery({
    queryKey: ['client-access'],
    queryFn: async () => {
      const { data } = await getClientAccessAsync();

      return {
        isActive: data.isActive,
        commercialOfferAccess: new Map(
          data.commercialOfferAccesses.map(({ folderTypologyId, borderCrossingServiceId }) => [
            folderTypologyId,
            borderCrossingServiceId,
          ]),
        ),
      };
    },
  });
